import Constants from "expo-constants"

/** endpoints for local and dev environments rolled back to *-dp instead of *-api
 * since *-api endpoints are not yet operational
 */

const ENV = {
    local: {
        baseHostname: 'localhost',
        hybrisBaseUrl: 'https://devcc-partner.bosch-pt.com/{subdomain}',
        oauth2ClientId: 'ciamids_29B53CD5-D6DB-4EAF-87D1-1EC6A4B4A351',
        oauth2ClientIdIcpm: 'b2b-dealer-portal',
        authorizationEndpoint: 'https://stage.identity.bosch.com/connect/authorize',
        authorizationEndpointIcpm: 'https://p32.authz.bosch.com/auth/realms/central_profile/protocol/openid-connect/auth',
        authorizationEndpointSso: 'https://p32.authz.bosch.com/auth/realms/central_profile/protocol/openid-connect/auth',
        tokenEndpoint: 'https://dev-upload-partner.bosch-pt.com/proxy/ciam',
        tokenEndpointIcpm: 'https://dev-upload-partner.bosch-pt.com/proxy/icpm',
        tokenEndpointSso: 'https://dev-upload-partner.bosch-pt.com/proxy/sso',
        logoutEndpoint: 'https://stage.identity.bosch.com/connect/endsession',
        logoutEndpointIcpm: 'https://p32.authz.bosch.com/auth/realms/central_profile/protocol/openid-connect/logout',
        fileUploadApi: 'https://dev-upload-partner.bosch-pt.com',
        orderHistoryApi: 'https://devcc-partner-api.bosch-pt.com/api/orders',
        duePaymentsApi: 'https://devcc-partner-api.bosch-pt.com/api/finance/due-payments',
        impersonationSearchApi: 'https://devcc-partner-api.bosch-pt.com/api/personification/search',
        orderTypesApi: 'https://dev-upload-partner.bosch-pt.com/personification/impersonate',
        creditLimitApi: 'https://devcc-partner-api.bosch-pt.com/api/finance',
        ticketsTrackingApi: 'https://devcc-partner-api.bosch-pt.com/api/complaints',
        allowReduxLogger: true,
        gaScriptProfile: 'global-pt-b2b-portal-pwa',
        gaScriptEnvironment: 'dev'
    },
    dev: {
        baseHostname: 'dev-mobile-partner.bosch-pt.com',
        hybrisBaseUrl: 'https://devcc-partner.bosch-pt.com/{subdomain}',
        oauth2ClientId: 'ciamids_29B53CD5-D6DB-4EAF-87D1-1EC6A4B4A351',
        oauth2ClientIdIcpm: 'b2b-dealer-portal',
        authorizationEndpoint: 'https://stage.identity.bosch.com/connect/authorize',
        authorizationEndpointIcpm: 'https://p32.authz.bosch.com/auth/realms/central_profile/protocol/openid-connect/auth',
        authorizationEndpointSso: 'https://p32.authz.bosch.com/auth/realms/central_profile/protocol/openid-connect/auth',
        tokenEndpoint: 'https://dev-upload-partner.bosch-pt.com/proxy/ciam',
        tokenEndpointIcpm: 'https://dev-upload-partner.bosch-pt.com/proxy/icpm',
        tokenEndpointSso: 'https://dev-upload-partner.bosch-pt.com/proxy/sso',
        logoutEndpoint: 'https://stage.identity.bosch.com/connect/endsession',
        logoutEndpointIcpm: 'https://p32.authz.bosch.com/auth/realms/central_profile/protocol/openid-connect/logout',
        fileUploadApi: 'https://dev-upload-partner.bosch-pt.com',
        orderHistoryApi: 'https://devcc-partner-api.bosch-pt.com/api/orders',
        duePaymentsApi: 'https://devcc-partner-api.bosch-pt.com/api/finance/due-payments',
        impersonationSearchApi: 'https://devcc-partner-api.bosch-pt.com/api/personification/search',
        orderTypesApi: 'https://dev-upload-partner.bosch-pt.com/personification/impersonate',
        creditLimitApi: 'https://devcc-partner-api.bosch-pt.com/api/finance',
        ticketsTrackingApi: 'https://devcc-partner-api.bosch-pt.com/api/complaints',
        allowReduxLogger: true,
        gaScriptProfile: 'global-pt-b2b-portal-pwa',
        gaScriptEnvironment: 'dev'
    },
    stg: {
        baseHostname: 'stg-mobile-partner.bosch-pt.com',
        hybrisBaseUrl: 'https://stgcc-partner.bosch-pt.com/{subdomain}',
        oauth2ClientId: 'ciamids_14BA671E-EE84-48BB-A603-08B214500E2B',
        oauth2ClientIdIcpm: 'b2b-dealer-portal',
        authorizationEndpoint: 'https://identity.bosch.com/connect/authorize',
        authorizationEndpointIcpm: 'https://p32.authz.bosch.com/auth/realms/central_profile/protocol/openid-connect/auth',
        authorizationEndpointSso: 'https://p32.authz.bosch.com/auth/realms/central_profile/protocol/openid-connect/auth',
        tokenEndpoint: 'https://stg-upload-partner.bosch-pt.com/proxy/ciam',
        tokenEndpointIcpm: 'https://stg-upload-partner.bosch-pt.com/proxy/icpm',
        tokenEndpointSso: 'https://stg-upload-partner.bosch-pt.com/proxy/sso',
        logoutEndpoint: 'https://identity.bosch.com/connect/endsession',
        logoutEndpointIcpm: 'https://p32.authz.bosch.com/auth/realms/central_profile/protocol/openid-connect/logout',
        fileUploadApi: "https://stg-upload-partner.bosch-pt.com",
        orderHistoryApi: 'https://stgcc-partner-api.bosch-pt.com/api/orders',
        duePaymentsApi: 'https://stgcc-partner-api.bosch-pt.com/api/finance/due-payments',
        impersonationSearchApi: 'https://stgcc-partner-api.bosch-pt.com/api/personification/search',
        orderTypesApi: 'https://stg-upload-partner.bosch-pt.com/personification/impersonate',
        creditLimitApi: "https://stgcc-partner-api.bosch-pt.com/api/finance",
        ticketsTrackingApi: 'https://stgcc-partner-api.bosch-pt.com/api/complaints',
        allowReduxLogger: false,
        gaScriptProfile: 'global-pt-b2b-portal-pwa',
        gaScriptEnvironment: 'qa'
    },
    prod: {
        baseHostname: 'mobile-partner.bosch-pt.com',
        hybrisBaseUrl: 'https://{subdomain}-partner.bosch-pt.com/{subdomain}',
        oauth2ClientId: 'ciamids_D30CD3CF-B0B4-4C6D-A3E4-827E27832563',
        oauth2ClientIdIcpm: 'b2b-dealer-portal',
        authorizationEndpoint: 'https://identity.bosch.com/connect/authorize',
        authorizationEndpointIcpm: 'https://p36.authz.bosch.com/auth/realms/central_profile/protocol/openid-connect/auth',
        authorizationEndpointSso: 'https://p36.authz.bosch.com/auth/realms/central_profile/protocol/openid-connect/auth',
        tokenEndpoint: 'https://upload-partner.bosch-pt.com/proxy/ciam',
        tokenEndpointIcpm: 'https://upload-partner.bosch-pt.com/proxy/icpm',
        tokenEndpointSso: 'https://upload-partner.bosch-pt.com/proxy/sso',
        logoutEndpoint: 'https://identity.bosch.com/connect/endsession',
        logoutEndpointIcpm: 'https://p36.authz.bosch.com/auth/realms/central_profile/protocol/openid-connect/logout',
        fileUploadApi: "https://upload-partner.bosch-pt.com",
        orderHistoryApi: 'https://am-cc-api-partner.bosch-pt.com/api/orders',
        duePaymentsApi: 'https://am-cc-api-partner.bosch-pt.com/api/finance/due-payments',
        impersonationSearchApi: 'https://am-cc-api-partner.bosch-pt.com/api/personification/search',
        orderTypesApi: 'https://upload-partner.bosch-pt.com/personification/impersonate',
        creditLimitApi: "https://am-cc-api-partner.bosch-pt.com/api/finance",
        ticketsTrackingApi: 'https://am-cc-api-partner.bosch-pt.com/api/complaints',
        allowReduxLogger: false,
        gaScriptProfile: 'global-pt-b2b-portal-pwa',
        gaScriptEnvironment: 'prod'
    }
}

const getConfig = (env = Constants.manifest.extra?.activeEnvironment) => {
    switch (env){
        case 'l': return ENV.local
        case 'd': return ENV.dev
        case 'q': {
         console.log = () => {};
         return ENV.stg
       }
        case 'p': {
          console.log = () => {};
          return ENV.prod
        }
        default: return ENV.dev
    }
}

export default getConfig
